import { Component, inject, input } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { Update } from 'src/app/interfaces/update';
import { Customer } from 'src/app/interfaces/customer';
import { Project } from 'src/app/interfaces/project';
import { TranslateModule } from '@ngx-translate/core';
import { UpdateListComponent } from '../update-list/update-list.component';
import { ImgFallBackDirective } from '../../directives/img-fallback.directive';
import { LoaderComponent } from '../loader/loader.component';
import { addIcons } from 'ionicons';
import { informationCircle } from 'ionicons/icons';
import { IonContent, IonIcon } from '@ionic/angular/standalone';

@Component({
  standalone: true,
  selector: 'app-embed',
  templateUrl: './embed.component.html',
  styleUrls: ['./embed.component.scss'],
  host: { style: 'display: contents' },
  imports: [
    LoaderComponent,
    ImgFallBackDirective,
    UpdateListComponent,
    TranslateModule,
    IonContent,
    IonIcon,
  ],
})
export class EmbedComponent {
  loading = input<boolean>(true);
  header = input<string>();
  theme = input<string>();
  info = input<string>();

  name = input<string>();
  logoUrl = input<string>();
  coverImageUrl = input<string>();
  metaLines = input<string[]>([]);

  updates = input<Update[] | undefined>();
  project = input<Project>();
  customer = input<Customer>();

  infoComponent = input<unknown>();
  infoComponentProps = input<Record<string, unknown>>({});
  private readonly modalCtrl = inject(ModalController);

  constructor() {
    addIcons({ informationCircle });
  }

  async showInfo() {
    const component = this.infoComponent();
    if (!component) return;

    const modal = await this.modalCtrl.create({
      component: component as never,
      componentProps: this.infoComponentProps(),
      cssClass: 'widget',
    });
    return await modal.present();
  }
}
